/**
 * This file originated from:
 * File: app/assets/javascripts/src-zugz/components/modals/confirmModal.js
 * In commit: de125d9c0dbfa23a5f12f049c70f4e9e185a6932
 * For ticket: GRINS-1507
 */

const module = { name: 'components/modals/confirmModal', exports: {} }; const exports = module.exports;

import { Fandango_adobeLaunch as Fandango_adobeLaunch_EventTypes } from '@grins/fd-modules/splits/onering-global';

const { EventTypes } = Fandango_adobeLaunch_EventTypes;
import { Fandango_debugLog as debugLog } from '@grins/fd-modules/splits/onering-global';

import Dialog from '@grins/fd-modules/components/modals/legacyDialog';

import Fandango_triggerEvent_triggerAnalyticsEvent from '@grins/fd-modules/Fandango/triggerEvent';

const { triggerAnalyticsEvent } = Fandango_triggerEvent_triggerAnalyticsEvent;

/* eslint-disable key-spacing */
const Selectors = Object.freeze({
  ID:            'confirm-modal',
  CANCEL_BTN:    '.js-confirm-modal-cancel-btn',
  DISMISS_BTN:   '.js-confirm-modal-dismiss-btn',
  OK_BTN:        '.js-confirm-modal-ok-btn',
  MSG_TEXT:      '.js-confirm-modal-msg',
  TITLE_TEXT:    '.js-confirm-modal-title',
  REPLACMENT:    '.js-confirm-modal-replacement-area',
});

const CSSClasses = Object.freeze({
  HIDE: 'hide',
});
/* eslint-enable key-spacing */

const defaultShowOptions = Object.freeze({
  /** @type {string}  (optional) Message text, default: "Are you sure?" */
  msg: '',
  /** @type {string}  (optional) Title text */
  title: '',
  /** @type {string}  (optional) Cancel button text, default: "Cancel" */
  cancelBtnText: '',
  /** @type {string}  (optional) OK button text, default: "OK" */
  okBtnText: '',
  /** @type {number}  (optional) Delay before showing dialog (default: 10ms) */
  delay: 10,
  /** @type {object}  (optional) This going to be used to add analytics data dynamically */
  extraAnalyticsData: {}
});

const defaultAttachOptions = Object.freeze({
  /**
   * Receives on parameter, a boolean indicating whether OK (`true`) or Cancel (`false`) was selected.
   * @type {function}  (required) method that's called when user closes the modal
   */
  onDone: null,
  /** @type {string}  (optional) ID of the dialog element */
  dialogID: Selectors.ID,
  /**
   * @type {string}
   * "ok", "cancel", or a selector for element to have initial focus; Default is "OK" Button
   */
  initialFocus: null,
  hideCancelBtn: false,
  hideOKBtn: false,
  extraAnalyticsData: {},
  /** @type {string}  (optional) Extra CSS class added to the dialog <section> element */
  customClass: '',
});

const CLOSE_ICON_SVG = '' +
  '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" role="presentation" aria-hidden="true">' +
  '<path d="M8.82081 9.99975L3.33238 15.4884L4.51092 16.6668L9.99934 11.1782L15.488 16.6667L16.6665 15.4882L11.1778 9.99971L16.6663 4.51101L15.4878 3.33252L9.9993 8.82122L4.51064 3.33275L3.33215 4.51128L8.82081 9.99975Z" fill="#F2F3F3"/>' +
  '</svg>';

const makeId = () => `${Selectors.ID}-${Math.random().toString(36).substr(2, 9)}`;

const stripDot = value => value.replace(/^\./, '');

const addModal = ({ dialogID, content = null, hideCancelBtn = false, hideOKBtn = false, hideDismissBtn = false, customClass = '' } = {}) => {
  let modalBodyStr;
  let useReplacement = false;

  if (content instanceof HTMLElement) {
    modalBodyStr = `<div class="${stripDot(Selectors.REPLACMENT)}"></div>`;
    useReplacement = true;
  } else if (typeof content === 'string') {
    modalBodyStr = content;
  } else {
    modalBodyStr = '' +
    `<h2 class="${stripDot(Selectors.TITLE_TEXT)} confirm-modal__title ${CSSClasses.HIDE}"></h2>` +
    `<p class="${stripDot(Selectors.MSG_TEXT)} confirm-modal__message">Are you sure?</p>`;
  }

  customClass = customClass ? ` ${customClass}` : '';
  const modalEle = document.createElement('div');
  modalEle.innerHTML = '' +
`<section id="${dialogID}" class="dialog style-lightbox animate-fade-in animate-speed-slow${customClass}" tabindex="-1" role="dialog">
  <div class="confirm-modal dialog-content animate-slide-down animate-speed-normal">
      <div class="confirm-modal__content">
        ${hideDismissBtn ?  '' : `<button class="${stripDot(Selectors.DISMISS_BTN)} confirm-modal__dismiss-btn" aria-label="Close dialog">${CLOSE_ICON_SVG}</button>`}
        ${modalBodyStr}
      </div>
      <p class="confirm-modal__btn-bar ${hideOKBtn && hideCancelBtn ? CSSClasses.HIDE : ''}">
          <button class="${stripDot(Selectors.OK_BTN)} btn btn--cta ${hideOKBtn ? CSSClasses.HIDE : '' }">OK</button>
          <button class="${stripDot(Selectors.CANCEL_BTN)} btn btn--secondary ${hideCancelBtn ? CSSClasses.HIDE : '' }">Cancel</button>
      </p>
  </div>
</section>`;

  if (useReplacement) {
    modalEle.querySelector(Selectors.REPLACMENT).replaceWith(content);
  }

  document.body.appendChild(modalEle.firstChild);
};

/**
 * Shows the dialog. Optionally change button or message texts.
 * @param {object} dialog private handle to initialized dialog
 * @param {object} opts (optional)
 */
const show = (dialog, opts) => {
  const { msg, okBtnText, cancelBtnText, delay, title } = {
    ...defaultShowOptions,
    ...opts,
  };

  msg && (dialog.ele.querySelector(Selectors.MSG_TEXT).innerHTML = msg);
  cancelBtnText && (dialog.ele.querySelector(Selectors.CANCEL_BTN).innerHTML = cancelBtnText);
  okBtnText && (dialog.ele.querySelector(Selectors.OK_BTN).innerHTML = okBtnText);
  if (title && dialog.isDynamic) {
    const titleEle = dialog.ele.querySelector(Selectors.TITLE_TEXT);
    titleEle.innerHTML = title;
    titleEle.classList.remove(CSSClasses.HIDE);
  }

  dialog.isOK = false;

  setTimeout(() => dialog.open(), delay);
};

const refocus = (modalEle, initialFocus) => {
  const selectors = [
    initialFocus === 'cancel' && Selectors.CANCEL_BTN,
    initialFocus !== 'ok' && initialFocus !== 'cancel' && initialFocus,
    Selectors.OK_BTN,
    Selectors.CANCEL_BTN,
  ];

  selectors.some((selector) => {
    const element = selector && modalEle.querySelector(selector);
    if (element?.focus) {
      element.focus();
      return true;
    }
  });
};

/**
 * Attaches events etc to existing HTML modal element.
 * @param {{ dialogID: string, onDone: function, initialFocus: string }} opts
 * @returns {{ show: function, isOK: boolean, ele: HTMLElement } | null}
 */
const attach = (opts) => {
  const { dialogID, onDone, extraAnalyticsData } = {
    ...defaultAttachOptions,
    ...opts,
  };

  const modalEle = document.getElementById(dialogID);
  if (!modalEle) {
    debugLog.error(module.name, `modal not found (${dialogID})`);
    return null;
  }

  const onDialogClose = typeof onDone === 'function' && onDone;
  if (!onDialogClose) {
    debugLog.error(module.name, 'missing required option "onDone"');
    return null;
  }

  const dialog = new Dialog(dialogID);
  dialog.ele = modalEle;

  const analyticsDefaults = {
    event: EventTypes.GENERIC_CLICKS,
    eventName: EventTypes.GENERIC_CLICKS,
    pageName: 'account | jurassic signup',
    pageType: 'checkout',
  };
  dialog.analytics = {...analyticsDefaults, ...extraAnalyticsData};

  dialog.on(Dialog.EventNames.CLOSED, () => onDialogClose(dialog.isOK));
  dialog.on(Dialog.EventNames.OPENED, () => refocus(modalEle, opts.initialFocus));

  const dismissBtn = modalEle.querySelector(Selectors.DISMISS_BTN);
  dismissBtn && dismissBtn.addEventListener('click', () => {
    dialog.close();
    triggerAnalyticsEvent(dialog.analytics.clickDetails, dialog.analytics);
  });

  const cancelBtn = modalEle.querySelector(Selectors.CANCEL_BTN);
  cancelBtn && cancelBtn.addEventListener('click', () => {
    dialog.close();
    triggerAnalyticsEvent(dialog.analytics.clickDetails, dialog.analytics);
  });

  modalEle.querySelector(Selectors.OK_BTN).addEventListener('click', () => {
    dialog.isOK = true;
    dialog.close();
  });

  return Object.assign(dialog, {
    isOK: false,
    show(opts) {
      show(dialog, opts);
    }
  });
};

/**
 * Creates & adds modal moarkup, then attaches it.
 * @param {{ dialogID: string=, onDone: function, initialFocus: string=, content: null | string | HTMLElement }} opts
 * @returns {{ show: function, isOK: boolean, ele: HTMLElement } | null}
 */
const newModal = (opts = {}) => {
  opts.dialogID = opts.dialogID || makeId();

  addModal(opts);

  const dialog = attach(opts);
  dialog && (dialog.isDynamic = true);
  return dialog;
};

export default {
    attach,
    newModal,
};
